import gql from 'graphql-tag';

export const INIT_ORG_USER = gql`
  mutation initUser($input: InitOrganizationUserInput!) {
    initOrganizationUser(input: $input) {
      ok
    }
  }
`;
